import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';
import 'firebase/compat/storage';
import { reduxFirestore, getFirestore, createFirestoreInstance } from 'redux-firestore';
import rootReducer from './rootReducers';
import fbConfig from '../config/database/firebase';
import onboardingApiErrorMiddleware from '../onboarding/utils/logger/reduxApiErrorMiddleware';

const store = createStore(
  rootReducer,
  compose(
    // onboardingApiErrorMiddleware only inspects ONBOARDING_*_ERR action types
    // (see file for details) — every other action, including the rest of the
    // admin app, passes through it untouched.
    applyMiddleware(thunk.withExtraArgument({ getFirestore, storage: firebase.storage }), onboardingApiErrorMiddleware),
    reduxFirestore(fbConfig),
  ),
);

export const rrfProps = {
  firebase,
  config: (fbConfig, { useFirestoreForProfile: true, userProfile: 'users', attachAuthIsReady: true }),
  dispatch: store.dispatch,
  createFirestoreInstance,
};

export default store;
